module.exports = __webpack_public_path__ + "static/img/camp-programs-hero-blue.png";